import React from 'react';
import './LoadingRing.css';

const LoadingRing = () => {
  return (
    <div className="loading-overlay">
      <div className="fancy-ring"></div>
      <div className="loading-text">Preparing Your Safari Adventure...</div>
    </div>
  );
};

export default LoadingRing;